import React from "react";
import PropTypes from "prop-types";
import NotificationSystem from "react-notification-system";

import Navbar from "./Navbar";
import * as notificationAction
  from "../modules/notification/actions/notificationsAction";


export class Layout extends React.Component {

  /**
   * Props structure
   * @type {{backLink: shim, isBackLink: shim, onBackLink: shim, rightSpace: shim, navbar: shim, title: *, description: *}}
   */
  static propTypes = {
    backLink: PropTypes.string,
    isBackLink: PropTypes.bool,
    onBackLink: PropTypes.func,
    rightSpace: PropTypes.object,
    navbar: PropTypes.bool,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    headerClass: PropTypes.string
  };

  /**
   * Default props
   * @type {{isBackLink: boolean, navbar: boolean}}
   */
  static defaultProps = {
    isBackLink: true,
    rightSpace: null,
    navbar: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isBackLink: () => this.props.backLink ||
        (this.props.isBackLink && typeof this.props.onBackLink === 'function'),
      onBackLink: () => {
        if (this.props.backLink) {
          window.location = this.props.backLink;
        } else {
          this.props.onBackLink();
        }
      }
    };
  }

  componentDidMount() {
    notificationAction.setup(this.refs.notificationSystem);
  }

  render() {
    const environments = { local: 'Local', dev: 'Development', stage: 'Stage', prod: ''};

    return (
      <div id="wrapper">
        <NotificationSystem ref="notificationSystem"/>
        {this.props.navbar && <Navbar/>}
        <div className={`pageHeader ${this.props.headerClass}`}>
          <div className={`environment environment-${process.env.STAGE}`}>{environments[process.env.STAGE]}</div>
          <div id="pageTitle" className="flexBox center-center">
            <div className="flex left">
              {this.state.isBackLink() &&
              <div className="backBox" onClick={this.state.onBackLink}>
                <i className="fa fa-angle-left"/>
              </div>}
            </div>
            <div className="title">
              {this.props.title}
            </div>
            <div className="flex right">
              {this.props.rightSpace}
            </div>
          </div>
          <div className="descriptionContainer">
            <div className="description">{this.props.description}</div>
          </div>
        </div>
        <div className="contentContainer">
          {this.props.children}
        </div>
      </div>
    );
  }
}
